import * as XLSX from 'xlsx';

const VENTE_MAG_SHEET = 'VENTE MAG';
const VENTE_SET_SHEET = 'VENTE SET';
const VENTE_NEWSLETTER_SHEET = 'VENTE NEWLETTERS';
const VENTE_WEB_SHEETS = ['VENTE WEB 2026', 'VENTE WEB'];

async function readVenteMatrixFromFile(file, sheetNameOrNames) {
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  const sheetNames = Array.isArray(sheetNameOrNames) ? sheetNameOrNames : [sheetNameOrNames];

  if (ext === 'csv' || ext === 'txt') {
    const text = (await file.text()).replace(/^\uFEFF/, '');
    const delimiter = text.includes(';') ? ';' : ',';
    const workbook = XLSX.read(text, { type: 'string', FS: delimiter });
    const sheet = workbook.Sheets[workbook.SheetNames[0]];

    return sheetToMatrix(sheet);
  }

  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: 'array', cellDates: false });
  const resolvedSheet = sheetNames.find((name) => workbook.SheetNames.includes(name))
    ?? workbook.SheetNames[0];
  const sheet = workbook.Sheets[resolvedSheet];

  return sheetToMatrix(sheet);
}

function cellToText(cell) {
  if (!cell) return '';
  if (cell.t === 'n' && cell.z && XLSX.SSF?.parse_date_code) {
    const date = XLSX.SSF.parse_date_code(cell.v);
    if (date) {
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(date.d)}/${pad(date.m)}/${date.y}`;
    }
  }
  if (cell.w != null && String(cell.w) !== '') return String(cell.w);
  if (cell.v == null) return '';
  if (cell.t === 's' || typeof cell.v === 'string') return String(cell.v);
  if (cell.t === 'n' && cell.z && XLSX.SSF?.parse_date_code) {
    const date = XLSX.SSF.parse_date_code(cell.v);
    if (date) {
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(date.d)}/${pad(date.m)}/${date.y}`;
    }
  }
  return String(cell.v);
}

function sheetToMatrix(sheet) {
  const ref = sheet['!ref'];
  if (!ref) return [];

  const range = XLSX.utils.decode_range(ref);
  const matrix = [];

  for (let rowIndex = range.s.r; rowIndex <= range.e.r; rowIndex += 1) {
    const row = [];
    for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex += 1) {
      const address = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
      row.push(cellToText(sheet[address]));
    }
    matrix.push(row);
  }

  return matrix;
}

/**
 * @param {File} file
 * @returns {Promise<unknown[][]>}
 */
export async function readVenteMagMatrixFromFile(file) {
  return readVenteMatrixFromFile(file, VENTE_MAG_SHEET);
}

/**
 * @param {File} file
 * @returns {Promise<unknown[][]>}
 */
export async function readVenteSetMatrixFromFile(file) {
  return readVenteMatrixFromFile(file, VENTE_SET_SHEET);
}

/**
 * @param {File} file
 * @returns {Promise<unknown[][]>}
 */
export async function readVenteNewsletterMatrixFromFile(file) {
  return readVenteMatrixFromFile(file, VENTE_NEWSLETTER_SHEET);
}

/**
 * @param {File} file
 * @returns {Promise<unknown[][]>}
 */
export async function readVenteWebMatrixFromFile(file) {
  return readVenteMatrixFromFile(file, VENTE_WEB_SHEETS);
}
